import React from "react";

interface DeleteBannerProps {
  show?: boolean;
  bannerText?: string;
}

const DeleteBanner: React.FC<DeleteBannerProps> = ({ show = false, bannerText = "" }) => {
  if (!show) return null;

  return (
    <div
      className="ds-banner ds-banner__bg--white ds-banner--icon !mb-[24px]"
      data-ds-variant="basic"
      data-ds-version="1"
      data-ds-theme="vessel"
      aria-labelledby="delete-banner-title"
      style={{
        border: '2px solid var(--Color-Blue-Deep, #003B71)',
        borderRadius: '8px',
        overflow: 'hidden',
      }}
    >
      <div className="w-full flex items-center gap-4 px-4 py-4 min-h-[76px]">
        <img
          src="/assets/images/informationIcon.svg"
          alt=""
          style={{ width: '38px', height: '38px', flex: '0 0 auto' }}
        />
        <div
          className="p1 -medium !mb-0"
          style={{ color: 'var(--Color-Inky, #0D1C3D)', lineHeight: '24px' }}
        >
          {bannerText} has been deleted.
        </div>
      </div>
    </div>
  );
};

export default DeleteBanner;
